import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-branding-tab-info',
  templateUrl: './branding-tab-info.component.html'
})
export class BrandingTabInfoComponent implements OnInit {

  constructor() {
    // Must not be empty. It's approved by a comment.
  }

  ngOnInit(): void {
    // Must not be empty. It's approved by a comment.
  }

}
